export default "__VITE_ASSET__CQ_5LdUU__"